import React, { useEffect, useRef, useState } from 'react';
import Layout1 from './editorForm/layouts/Layout1';
import Layout2 from './editorForm/layouts/Layout2';
import Layout3 from './editorForm/layouts/Layout3';
import Layout4 from './editorForm/layouts/Layout4';
import Layout4B from './editorForm/layouts/Layout4B';
import Layout4C from './editorForm/layouts/Layout4C';
import Layout6 from './editorForm/layouts/Layout6';
import Layout7 from './editorForm/layouts/Layout7';
import Layout5 from './editorForm/layouts/Layout5';
import './VideoEditor.css';

const VideoEditor = ({ layout, data }) => {
  const containerRef = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new ResizeObserver(() => {
      const reactDom = el?.getBoundingClientRect();

      setSize({
        width: reactDom?.width,
        height: reactDom?.height,
      });
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="video-editor" ref={containerRef}>
      {layout === 'layout1' && <Layout1 data={data} parentSize={size} />}
      {layout === 'layout2' && <Layout2 data={data} parentSize={size} />}
      {layout === 'layout3' && <Layout3 data={data} parentSize={size} />}
      {layout === 'layout4' && <Layout4 data={data} parentSize={size} />}
      {layout === 'layout4B' && <Layout4B data={data} parentSize={size} />}
      {layout === 'layout4C' && <Layout4C data={data} parentSize={size} />}
      {layout === 'layout6' && <Layout6 data={data} parentSize={size} />}
      {layout === 'layout7' && <Layout7 data={data} parentSize={size} />}
      {layout === 'layout5' && <Layout5 data={data} parentSize={size} />}
    </div>
  );
};

export default VideoEditor;
